import CloseIcon from "../../../../../../assets/svg/close-icon";
import Button from "../../../../../../components/Button/Button";
import Modal from "../../../../../../components/Modal/Modal";
import VerbaFloLogoWithAlertIcon from "../../../../../../assets/svg/verbaflo-logo-with-alert-icon";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../redux/store";

interface UnsavedChangesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  onLeaveWithoutSaving: () => void;
}

export const UnsavedChangesModal = ({
  isOpen,
  onClose,
  onSave,
  onLeaveWithoutSaving,
}: UnsavedChangesModalProps) => {
  const fontSize = useSelector(
    (state: RootState) => state.fontSettings.fontSize,
  );
  return (
    <Modal
      open={isOpen}
      onOpenChange={onClose}
      showHeader={false}
      showCloseButton={false}
      contentClassName={`bg-popper-bg-fixed-white dark:bg-popper-bg-fixed-white-dk rounded-lg ${fontSize > 2 ? "max-w-[440px]" : "max-w-[356px]"} shadow-popper-blur-effect backdrop-blur-2xl !z-[99999999]`}
      overlayClassName="!bg-black/60 !z-[9999999]"
      bodyClassName="!px-6 !py-[18px] !relative"
    >
      <button
        className="absolute top-3 right-3 w-[16px] h-[16px] bg-gray-100 dark:bg-gray-100-dk rounded-full flex flex-col items-center justify-center z-10"
        onClick={onClose}
      >
        <CloseIcon className="w-[6px] h-[6px] text-verba-indigo dark:text-verba-indigo-dk" />
      </button>

      <div className="flex items-center justify-center mb-3">
        <VerbaFloLogoWithAlertIcon className="w-9 h-9" />
      </div>

      <div className="flex flex-col justify-center items-center gap-0.5 mb-6 text-center">
        <div className="text-heading-text dark:text-heading-text-dk text-md font-semibold">
          Unsaved changes
        </div>
        <div className="text-verba-field-label dark:text-verba-field-label-dk text-sm">
          You have unsaved changes. If you leave now, your progress will be
          lost. Do you want to continue without saving?
        </div>
      </div>

      <div className="flex items-center justify-center gap-2">
        <Button
          innerText="Go Back & Save"
          onClick={onSave}
          buttonContainerClass="w-full py-1 text-md font-semibold bg-verba-indigo dark:bg-verba-indigo-dk text-pure-white dark:text-pure-white-dk rounded-lg"
        />
        <Button
          innerText="Leave Without Saving"
          onClick={onLeaveWithoutSaving}
          buttonContainerClass="w-full py-[3px] text-md font-semibold text-verba-red-alert dark:text-verba-red-alert-dk border border-verba-red-alert dark:border-verba-red-alert-dk rounded-lg bg-transparent"
        />
      </div>
    </Modal>
  );
};
